<template>
  <div>
    <el-card class="box-card tablecard mt10 textLeft" shadow="never">
      <div slot="header" class="clearfix">
        <span><i class="fa fa-gift fs14" /> Weekly accumulated data size in the last 13 weeks ({{nowTime}}) </span>
      </div>
      <div>
        <el-switch
          class="mb20"
          v-model="isShowlable"
          active-text="显示数值"
          @change="handleChangelable">
        </el-switch>
        <div id="myCharts" :style="{height: '450px'}"></div>
      </div>
    </el-card>
    <el-card class="box-card tablecard mt10 textLeft" shadow="never">
      <div slot="header" class="clearfix">
        <span><i class="fa fa-gift fs14" /> Monthly accumulated data size in the last 12 months </span>
      </div>
      <div>
        <el-switch
          class="mb20"
          v-model="isShowlable2"
          active-text="显示数值"
          @change="handleChangelable2">
        </el-switch>
        <div id="myCharts2" :style="{height: '450px'}"></div>
      </div>
    </el-card>
    <el-card class="box-card tablecard mt10 textLeft" shadow="never">
      <div slot="header" class="clearfix">
        <span><i class="fa fa-gift fs14" /> Yearly accumulated data size since {{title3}} </span>
      </div>
      <div>
        <el-switch
          class="mb20"
          v-model="isShowlable3"
          active-text="显示数值"
          @change="handleChangelable3">
        </el-switch>
        <div id="myCharts3" :style="{height: '450px'}"></div>
      </div>
    </el-card>
  </div>
</template>

<script>
import { getStatDataAllByTime, getSysVal } from '@/api'
import echarts from 'echarts'
export default {
  name: 'statistics',
  data() {
    return {
      option: {
        title: {
          // text: 'Stacked Line'
          subtext: '',
          left: '5%'
        },
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: ['已经提交的总数据量', '公开的总数据量', '未公开的总数据量']
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        toolbox: {
          feature: {
            mark: { show: true },
            // dataView: { show: true, readOnly: false },
            // magicType: { show: true, type: ['line', 'bar', 'stack'] },
            magicType: { show: true, type: ['line', 'bar'] },
            // restore: { show: true },
            saveAsImage: { show: true }
          }
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: [],
          axisLabel: {
            interval: 0,
            rotate: 33
          }
        },
        yAxis: {
          type: 'value',
          name: 'TB',
          min: 'dataMin'
        },
        height: '300',
        width: '90%',
        dataZoom: [
          {
            type: 'slider',
            xAxisIndex: 0,
            filterMode: 'none'
          },
          {
            type: 'slider',
            yAxisIndex: 0,
            left: '96%'
          }
        ],
        series: [
          {
            name: '已经提交的总数据量',
            type: 'line',
            data: [],
            label: {
              show: false,
              position: 'top'
            }
          },
          {
            name: '公开的总数据量',
            type: 'line',
            data: [],
            label: {
              show: false,
              position: 'top'
            }
          },
          {
            name: '未公开的总数据量',
            type: 'line',
            data: [],
            label: {
              show: false,
              position: 'top'
            }
          }
        ]
      },
      ajax_data: {
        search:{
          stat_type: 'week'
        },
        page:{
          startPage: 1,
          pageLength: 0
        },
        order:{
          item: '',
          type: ''
        }
      },
      title3: '',
      chartsArr1: [],
      chartsArr2: [],
      chartsArr3: [],
      xAxis1: [],
      xAxis2: [],
      xAxis3: [],
      isShowlable: false,
      isShowlable2: false,
      isShowlable3: false,
      ajax_datatime: {},
      nowTime: ''
    }
  },
  mounted() {
    getStatDataAllByTime(this.ajax_data).then(res => {
      this.chartsArr1 = res.result
      let arr1 = []
      for(let i = 13; i >= 1; i--) {
        let xastr = '过去第'+i+'周'
        arr1.push(xastr)
      }
      this.option.xAxis.data = this.xAxis1 = arr1
      let subArr = []
      let pubArr = []
      let unpubArr = []
      // console.log(resultArr)
      this.chartsArr1.map(item => {
        subArr.push(item.submitted)
        pubArr.push(item.public)
        unpubArr.push(item.nonpublic)
      })
      // console.log(subArr)
      // console.log(pubArr)
      // console.log(unpubArr)
      this.option.series[0].data = subArr
      this.option.series[1].data = pubArr
      this.option.series[2].data = unpubArr
      let charts = this.$echarts.init(document.getElementById('myCharts'))
      charts.setOption(this.option)
    })
    this.ajax_data.search.stat_type = 'month'
    getStatDataAllByTime(this.ajax_data).then(res => {
      this.chartsArr2 = res.result
      let xastr = []
      let subArr = []
      let pubArr = []
      let unpubArr = []
      this.chartsArr2.map(item => {
        let substr = item.statmonth.substring(0, 4);
        let newstr = substr+'年'+item.statmonth.substring(4, 6)+'月'
        xastr.push(newstr)
        subArr.push(item.submitted)
        pubArr.push(item.public)
        unpubArr.push(item.nonpublic)
      })
      this.option.xAxis.data = this.xAxis2 = xastr
      this.option.series[0].data = subArr
      this.option.series[1].data = pubArr
      this.option.series[2].data = unpubArr
      let charts = this.$echarts.init(document.getElementById('myCharts2'))
      charts.setOption(this.option)
    })
    this.ajax_data.search.stat_type = 'year'
    getStatDataAllByTime(this.ajax_data).then(res => {
      this.chartsArr3 = res.result
      this.title3 = res.result[0].statyear
      let xastr = []
      let subArr = []
      let pubArr = []
      let unpubArr = []
      this.chartsArr3.map(item => {
        xastr.push(item.statyear+'年')
        subArr.push(item.submitted)
        pubArr.push(item.public)
        unpubArr.push(item.nonpublic)
      })
      this.option.xAxis.data = this.xAxis3 = xastr
      this.option.series[0].data = subArr
      this.option.series[1].data = pubArr
      this.option.series[2].data = unpubArr
      let charts = this.$echarts.init(document.getElementById('myCharts3'))
      charts.setOption(this.option)
    })
  },
  created() {
    getSysVal(this.ajax_datatime).then(res => {
      // const parts = res.result[0].sysdate.split(" ")
      // console.log(parts)
      let timestr = res.result[0].sysdate
      this.nowTime = timestr
      // let timearr = timestr.split("-")
      // this.yearstr = timearr[0]
    })
  },
  methods: {
    handleChangelable(val) {
      this.option.xAxis.data = this.xAxis1
      let subArr = []
      let pubArr = []
      let unpubArr = []
      // console.log(resultArr)
      this.chartsArr1.map(item => {
        subArr.push(item.submitted)
        pubArr.push(item.public)
        unpubArr.push(item.nonpublic)
      })
      this.option.series[0].data = subArr
      this.option.series[1].data = pubArr
      this.option.series[2].data = unpubArr

      this.option.series[0].label.show = val
      this.option.series[1].label.show = val
      this.option.series[2].label.show = val
      let charts = this.$echarts.init(document.getElementById('myCharts'))
      charts.setOption(this.option)
    },
    handleChangelable2(val) {
      let xastr = []
      let subArr = []
      let pubArr = []
      let unpubArr = []
      this.chartsArr2.map(item => {
        let substr = item.statmonth.substring(0, 4);
        let newstr = substr+'年'+item.statmonth.substring(4, 6)+'月'
        xastr.push(newstr)
        subArr.push(item.submitted)
        pubArr.push(item.public)
        unpubArr.push(item.nonpublic)
      })
      this.option.xAxis.data = this.xAxis2 = xastr
      this.option.series[0].data = subArr
      this.option.series[1].data = pubArr
      this.option.series[2].data = unpubArr
      
      this.option.series[0].label.show = val
      this.option.series[1].label.show = val
      this.option.series[2].label.show = val
      let charts = this.$echarts.init(document.getElementById('myCharts2'))
      charts.setOption(this.option)
    },
    handleChangelable3(val) {
      let xastr = []
      let subArr = []
      let pubArr = []
      let unpubArr = []
      this.chartsArr3.map(item => {
        xastr.push(item.statyear+'年')
        subArr.push(item.submitted)
        pubArr.push(item.public)
        unpubArr.push(item.nonpublic)
      })
      this.option.xAxis.data = this.xAxis3 = xastr
      this.option.series[0].data = subArr
      this.option.series[1].data = pubArr
      this.option.series[2].data = unpubArr

      this.option.series[0].label.show = val
      this.option.series[1].label.show = val
      this.option.series[2].label.show = val
      let charts = this.$echarts.init(document.getElementById('myCharts3'))
      charts.setOption(this.option)
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

</style>
